import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { formatDateRange, formatTimeRange } from 'src/app/util/format-utils';
import { ActiveDays } from '../working-days-of-week/working-days-of-week.component';
import { HttpParams } from '@angular/common/http';
import { UserService } from 'src/app/services/user.service';
import { Blueshift } from '@bluecrew/crew-member-backend-angular-client';
dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-job-brief-modal',
  templateUrl: './job-brief-modal.component.html',
  styleUrls: ['./job-brief-modal.component.scss'],
})
export class JobBriefModalComponent implements OnInit {

  timeRange: string = undefined;
  dateRange: string = undefined;
  dressCode?: string = undefined;

  @Input() job: ModalJobInfo;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly modalCtrl: ModalController,
    private readonly navCtrl: NavController,
    private readonly userService: UserService,
  ) {}

  async ngOnInit() {
    this.timeRange = formatTimeRange(dayjs(this.job.startTimestamp), dayjs(this.job.endTimestamp));
    this.dateRange = formatDateRange(dayjs(this.job.startTimestamp), dayjs(this.job.endTimestamp));
    if (this.job.dressCode) {
      this.dressCode = this.job.dressCode;
    } else {
      this.dressCode = undefined;
    }
    this.changeDetectorRef.detectChanges();
  }

  fallbackWorkplaceImg = ($event: ErrorEvent) => {
    ($event.target as HTMLImageElement).src = '/assets/icons/building.svg';
  };

  async onViewFullJob() {
    await this.modalCtrl.dismiss();
    this.navCtrl.navigateForward(AppRoutingUtil.getPositionJobRoute(this.job.externalId));
  }

  async onDismiss() {
    await this.modalCtrl.dismiss();
  }

  async onGetDirections() {
    const params = new HttpParams()
      .set('api', '1')
      .set('destination', `${this.job.addressLine1}, ${this.job.addressLine2}`);
    window.open(`https://www.google.com/maps/dir/?${params.toString()}`);
  }

  isUserEligible(): boolean {
    return this.userService.isCurrentUserEligible();
  }
}

export interface ModalJobInfo {
  title: string;
  companyName: string;
  smallLogo: string;
  externalId: string;
  days: ActiveDays;
  startTimestamp: string;
  endTimestamp: string;
  addressLine1: string;
  addressLine2: string;
  dressCode?: string;
  lat: number;
  lng: number;
  blueshifts: Blueshift[]
}
